import * as React from 'react';
import './Page.css';
import { IPageDto, PageSectionDto, HomeDto } from '../../@types/api';
import { ClassNames } from '../../_helpers/ClassNames';
import DocumentMeta from 'react-document-meta';
import AppProvider, { AppContextProps } from '../../_context/App';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Home } from '../Home/Home';
import PageSection from '../PageSection/PageSection';
import { Spinner } from '../Spinner/Spinner';
import objectFitImages from 'object-fit-images';

export type PageProps = {};

type State = {
  page?: IPageDto;
};
type Props = PageProps & {
  appContext: AppContextProps;
} & RouteComponentProps<any>;
class PageUnwrapped extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      page: props.appContext.app && props.appContext.app.Page,
    };
  }

  public componentDidMount() {
    if (!this.state.page) {
      this._fetch();
    }

    objectFitImages();
  }

  public componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this._fetch();
    }
  }

  public render() {
    const { page } = this.state;

    return (
      <div className={ClassNames('page', '')}>
        <div className={ClassNames('page', 'content')}>
          {page ? (
            <React.Fragment>
              <DocumentMeta
                title={page.PageTitle || ''}
                description={page.Description || ''}
              />
              {page.type === 'Home' && <Home {...(page as HomeDto)} />}
              {page.type === 'PageSection' && (
                <PageSection {...(page as PageSectionDto)} />
              )}
            </React.Fragment>
          ) : (
            <Spinner />
          )}
        </div>
      </div>
    );
  }

  private _fetch() {
    this.setState(() => {
      this.props.appContext.get(this.props.location.pathname).then((result) => {
        this.setState(() => ({ page: result }));
      });
      return { page: undefined };
    });
  }
}

export const Page = withRouter(AppProvider.Inject(PageUnwrapped));

export default Page;



// WEBPACK FOOTER //
// ./src/Components/Page/Page.tsx